/* eslint-disable react-hooks/exhaustive-deps */
// import React, {
//   createContext,
//   useCallback,
//   useContext,
//   useMemo,
//   useRef,
//   useSyncExternalStore
// } from 'react';
// import type { ReactNode } from 'react';

// export function createSelectorProxy(): {
//   proxy: Record<string, any>;
//   getPath: () => string[];
// } {
//   const lastPath: string[] = [];

//   let proxy: Record<string, any>; // <-- Declare before initializing

//   proxy = new Proxy(
//     {},
//     {
//       get(_, key: string) {
//         lastPath.push(key);
//         return proxy;
//       }
//     }
//   );

//   return {
//     proxy,
//     getPath: () => [...lastPath]
//   };
// }

// function getNestedValue<T extends Record<string, any>>(
//   obj: T,
//   path: string[]
// ): any {
//   return path.reduce((acc, key) => acc?.[key], obj);
// }

// function setNestedValue<T extends Record<string, any>>(
//   obj: T,
//   path: string[],
//   value: any,
//   options?: { forceClone?: boolean }
// ): T {
//   const newObj = { ...obj };
//   let temp: any = newObj;

//   path.forEach((key, index) => {
//     if (index === path.length - 1) {
//       if (typeof value === 'function') {
//         temp[key] = value(temp[key]);
//       } else if (options?.forceClone) {
//         temp[key] = structuredClone(value); // full deep clone
//       } else if (
//         typeof value === 'object' &&
//         value !== null &&
//         !Array.isArray(value)
//       ) {
//         temp[key] = { ...temp[key], ...value }; // shallow merge
//       } else {
//         temp[key] = value;
//       }
//     } else {
//       temp[key] = { ...temp[key] };
//       temp = temp[key];
//     }
//   });

//   return newObj;
// }

// export function createStore<Store extends Record<string, any>>(
//   initialState: Store
// ) {
//   function useStoreData(defaultState?: Store) {
//     const store = useRef<Store>(
//       structuredClone({ ...initialState, ...defaultState })
//     );

//     const subscribers = useRef(new Set<() => void>());

//     const get = useCallback(() => store.current, []);
//     const set = useCallback(
//       (value: Partial<Store> | ((prev: Store) => Partial<Store>)) => {
//         const newState =
//           typeof value === 'function' ? value(store.current) : value;
//         store.current = { ...store.current, ...newState };
//         subscribers.current.forEach(cb => cb());
//       },
//       []
//     );

//     const subscribe = useCallback((cb: () => void) => {
//       subscribers.current.add(cb);
//       return () => subscribers.current.delete(cb);
//     }, []);

//     return { get, set, subscribe };
//   }

//   const StoreContext = createContext<ReturnType<typeof useStoreData> | null>(
//     null
//   );

//   // function Provider({ children }: { children: ReactNode }) {
//   //   return (
//   //     <StoreContext.Provider value={useStoreData()}>
//   //       {children}
//   //     </StoreContext.Provider>
//   //   );
//   // }

//   function Provider({
//     children,
//     initialState
//   }: {
//     children: ReactNode;
//     initialState?: Partial<Store>;
//   }) {
//     const storeData = useStoreData(initialState as Store);
//     return (
//       <StoreContext.Provider value={storeData}>
//         {children}
//       </StoreContext.Provider>
//     );
//   }

//   function useStore<SelectorOutput>(
//     selector: (store: Store) => SelectorOutput
//   ): [
//     SelectorOutput,
//     (
//       value:
//         | Partial<SelectorOutput>
//         | ((prev: SelectorOutput) => Partial<SelectorOutput>),
//       options?: { forceClone?: boolean }
//     ) => void
//   ] {
//     const store = useContext(StoreContext);
//     if (!store) throw new Error('Store not found');

//     const trackedPath = useMemo(() => {
//       const { proxy, getPath } = createSelectorProxy();
//       selector(proxy as Store);
//       return getPath();
//     }, [selector.toString()]);

//     const state = useSyncExternalStore(store.subscribe, () =>
//       getNestedValue(store.get(), trackedPath)
//     );

//     const setState = useCallback(
//       (
//         value:
//           | Partial<SelectorOutput>
//           | ((prev: SelectorOutput) => Partial<SelectorOutput>),
//         options?: { forceClone?: boolean }
//       ) => {
//         store.set(prev => setNestedValue(prev, trackedPath, value, options));
//       },
//       [store, trackedPath]
//     );

//     return [state, setState];
//   }

//   function useSetStore() {
//     const store = useContext(StoreContext);
//     if (!store) throw new Error('Store not found');
//     return store.set;
//   }

//   function useSetStorePath<SelectorOutput>(
//     selector: (store: Store) => SelectorOutput
//   ) {
//     const store = useContext(StoreContext);
//     if (!store) throw new Error('Store not found');

//     const trackedPath = useMemo(() => {
//       const { proxy, getPath } = createSelectorProxy();
//       selector(proxy as Store);
//       return getPath();
//     }, [selector.toString()]);

//     return useCallback(
//       (
//         value:
//           | Partial<SelectorOutput>
//           | ((prev: SelectorOutput) => Partial<SelectorOutput>),
//         options?: { forceClone?: boolean }
//       ) => {
//         store.set(prev => setNestedValue(prev, trackedPath, value, options));
//       },
//       [store, trackedPath]
//     );
//   }

//   return {
//     Provider,
//     useStore,
//     useSetStore,
//     useSetStorePath
//   };
// }

import React, {
  useRef,
  createContext,
  useContext,
  useCallback,
  useSyncExternalStore,
  useMemo
} from 'react';
import type { ReactNode } from 'react';
import type { GroupedUoms } from '../service/api/get-uom-details';

export function createSelectorProxy(): {
  proxy: Record<string, any>;
  getPath: () => string[];
} {
  const lastPath: string[] = [];

  let proxy: Record<string, any>; // <-- Declare before initializing

  proxy = new Proxy(
    {},
    {
      get(_, key: string) {
        lastPath.push(key);
        return proxy;
      }
    }
  );

  return {
    proxy,
    getPath: () => [...lastPath]
  };
}

function setNestedValue<T extends Record<string, any>>(
  obj: T,
  path: string[],
  value: any,
  options?: { forceClone?: boolean }
): T {
  const newObj = { ...obj };
  let temp: any = newObj;

  path.forEach((key, index) => {
    if (index === path.length - 1) {
      if (typeof value === 'function') {
        temp[key] = value(temp[key]);
      } else if (options?.forceClone) {
        temp[key] = structuredClone(value); // full deep clone
      } else if (
        typeof value === 'object' &&
        value !== null &&
        !Array.isArray(value)
      ) {
        temp[key] = { ...temp[key], ...value }; // shallow merge
      } else {
        temp[key] = value;
      }
    } else {
      temp[key] = { ...temp[key] };
      temp = temp[key];
    }
  });

  return newObj;
}

export function createStore<Store extends object>(
  initialState: Store = {} as Store
) {
  function useStoreData<Props>(props?: Props): {
    get: () => Store;
    // useSetStorePath (below) passes an updater function here
    // (`store.set(prev => setNestedValue(...))`). `set` unwraps function
    // values before merging, so path-based setters (e.g. setSelectedMenu,
    // setIsLoading) actually take effect instead of silently no-op'ing.
    set: (value: Partial<Store> | ((prev: Store) => Partial<Store>)) => void;
    subscribe: (callback: () => void) => () => void;
  } {
    const store = useRef({ ...initialState, ...props });

    const get = useCallback(() => store.current, []);

    const subscribers = useRef(new Set<() => void>());

    const set = useCallback(
      (value: Partial<Store> | ((prev: Store) => Partial<Store>)) => {
        const newState =
          typeof value === 'function' ? value(store.current) : value;
        store.current = { ...store.current, ...newState };
        subscribers.current.forEach(callback => {
          callback();
        });
      },
      []
    );

    const subscribe = useCallback((callback: () => void) => {
      subscribers.current.add(callback);
      return () => subscribers.current.delete(callback);
    }, []);

    return {
      get,
      set,
      subscribe
    };
  }

  type UseStoreDataReturnType = ReturnType<typeof useStoreData>;

  type ProviderParameters = {
    children: ReactNode;
    initialState?: Partial<Store>;
    [props: string]: any;
  };

  const StoreContext = createContext<UseStoreDataReturnType | null>(null);

  function Provider({
    children,
    initialState: seededState,
    ...props
  }: ProviderParameters) {
    return (
      <StoreContext.Provider value={useStoreData({ ...props, ...seededState })}>
        {children}
      </StoreContext.Provider>
    );
  }

  function useStore<SelectorOutput>(
    selector: (store: Store) => SelectorOutput
  ): [SelectorOutput, (value: Partial<Store>) => void] {
    const store = useContext(StoreContext);
    if (!store) {
      throw new Error('Store not found');
    }

    const state = useSyncExternalStore(store.subscribe, () =>
      selector(store.get())
    );

    return [state, store.set];
  }

  function useSetStore() {
    const store = useContext(StoreContext);
    if (!store) {
      throw new Error('Store not found');
    }

    return store.set;
  }

  function useSetStorePath<SelectorOutput>(
    selector: (store: Store) => SelectorOutput
  ) {
    const store = useContext(StoreContext);
    if (!store) throw new Error('Store not found');

    const trackedPath = useMemo(() => {
      const { proxy, getPath } = createSelectorProxy();
      selector(proxy as Store);
      return getPath();
    }, [selector.toString()]);

    return useCallback(
      (
        value:
          | Partial<SelectorOutput>
          | ((prev: SelectorOutput) => Partial<SelectorOutput>),
        options?: { forceClone?: boolean }
      ) => {
        store.set(prev => setNestedValue(prev, trackedPath, value, options));
      },
      [store, trackedPath]
    );
  }

  return {
    Provider,
    useStore,
    useSetStore,
    useSetStorePath
  };
}

export const initilaModuleState = {
  name: '',
  remoteName: '',
  remoteUrl: '',
  moduleName: '',
  subModules: []
};

// Then define `initialStoreState` which uses `initilaModuleState`
export interface IStore {
  tabTitle: string;
  selectedLanguage: string;
  module: typeof initilaModuleState;
  tenantDetails: any;
  selectedTheme: string;
  userPermissions: any;
  uomDetails: Record<string, GroupedUoms>;
}

export const initialStoreState: IStore = {
  tabTitle: '',
  selectedLanguage: '',
  module: initilaModuleState,
  tenantDetails: '',
  selectedTheme: '',
  userPermissions: '',
  uomDetails: {}
};
